/*
  <rpg-product-row>: fetches product cards from a collection URL through Shopify's Section Rendering API
  (data-url already carries the section_id) and swaps them in for the skeleton. Shared by the "RPG product row"
  and "RPG related set" sections.
    data-limit      cards to show (default 8)
    data-exclude    product handle to leave out (the product being viewed)
    data-hide-empty hide the whole section instead of showing data-empty text when nothing comes back
*/
if (!customElements.get('rpg-product-row')) {
  class RpgProductRow extends HTMLElement {
    connectedCallback() {
      // A tag parsed after the class is defined connects before its children exist, so wait for the parser.
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.init(), { once: true });
      } else {
        this.init();
      }
    }
    init() {
      this.limit = parseInt(this.dataset.limit, 10) || 8;
      this.exclude = this.dataset.exclude || '';
      this.ul = this.querySelector('.rpg-grid');
      if (!this.ul) return;
      this.load().catch(() => this.finish([]));
    }
    async fetchPage(n) {
      const res = await fetch(this.dataset.url + '&page=' + n, { headers: { Accept: 'text/html' } });
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const grid = doc.querySelector('.rpg-grid');
      return { items: grid ? [...grid.children] : [], pages: grid ? parseInt(grid.dataset.pages || '1', 10) : 1 };
    }
    isExcluded(li) {
      if (!this.exclude) return false;
      const a = li.querySelector('a[href*="/products/"]');
      if (!a) return false;
      const path = a.getAttribute('href').split('?')[0];
      return path.split('/').pop() === this.exclude;
    }
    async load() {
      const first = await this.fetchPage(1);
      let items = first.items;
      // The available-only renderer may need more than one page before it finds enough buyable products.
      if (items.length < this.limit + 1 && first.pages > 1) {
        const extra = [];
        for (let n = 2; n <= Math.min(first.pages, 6); n++) extra.push(this.fetchPage(n));
        for (const page of await Promise.all(extra)) items = items.concat(page.items);
      }
      this.finish(items.filter((li) => !this.isExcluded(li)).slice(0, this.limit));
    }
    finish(items) {
      this.ul.classList.remove('rpg-grid--loading');
      this.ul.innerHTML = '';
      if (items.length === 0) {
        if ('hideEmpty' in this.dataset) {
          (this.closest('.shopify-section') || this).hidden = true;
          return;
        }
        this.ul.innerHTML = '<li class="rpg-empty">' + (this.dataset.empty || 'Nothing here right now.') + '</li>';
        return;
      }
      items.forEach((li) => this.ul.appendChild(li));
    }
  }
  customElements.define('rpg-product-row', RpgProductRow);
}
